import { z } from "zod";

export const WorkspaceSchema = z.object({
  id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  subscriptionStatus: z.string(),
  zeroDataRetention: z.boolean(),
  auditEnabled: z.boolean(),
});

export type Workspace = z.infer<typeof WorkspaceSchema>;
